import { render, staticRenderFns } from "./setUserNameDialog.vue?vue&type=template&id=46f3f8bd&scoped=true"
import script from "./setUserNameDialog.vue?vue&type=script&lang=js"
export * from "./setUserNameDialog.vue?vue&type=script&lang=js"
import style0 from "./setUserNameDialog.vue?vue&type=style&index=0&id=46f3f8bd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@2.7.16_babel-core@6.26.3_css-loader@6.10.0_webpack_07e6226cc05e6e3c31269f9c9c887956/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f3f8bd",
  null
  
)

export default component.exports